import { render } from "./Wheelchair.vue?vue&type=template&id=6ffbd1f2"
const script = {}
script.render = render

export default script